import { render } from "./SystemNav.vue?vue&type=template&id=c47b5c18"
import script from "./SystemNav.vue?vue&type=script&lang=js"
export * from "./SystemNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gerardo\\source\\repos\\Dorapp Web\\Dorapp Web\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__